import React, { Suspense } from 'react'
import { Navigate, useLocation } from 'react-router'

import { isLogin } from '../utils/helper'

interface PublicRouteProps {
  component: React.ElementType
  restricted?: boolean
}

const PublicRoute: React.FC<PublicRouteProps> = ({ component: Component, restricted = false }) => {
  const location = useLocation()

  if (isLogin() && restricted) {
    // Redirect to dashboard if user is logged in and tries to access a restricted route
    return <Navigate to="/cases" replace />
  }

  // Render the public component
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Component />
    </Suspense>
  )
}

export default PublicRoute
